import isEmpty from 'lodash/isEmpty';
import isNull from 'lodash/isNull';
import railsConfig from '../RailsConfig';
import {objectToQueryParams} from '@mmt/legacy-commons/Helpers/misc';
import {handleError} from './RailsConstant';
import fetch2 from '../fetch2';
import { _label } from '../vernacular/AppLanguage';

export const STATUS_API_ERROR = 'FAILURE';
export const STATUS_NON_RESPONSIVE_API_ERROR = 'ERROR';
export const STATUS_API_SUCCESS = 'SUCCESS';
export const STATUS_MOBILE_EMAIL_OTP_VERIFICATION_PENDING = 'VERIFY_EMAIL_AND_MOBILE';
export const STATUS_EMAIL_OTP_VERIFICATION_PENDING = 'VERIFY_EMAIL';
export const STATUS_MOBILE_OTP_VERIFICATION_PENDING = 'VERIFY_MOBILE';
export const STATUS_LIMIT_EXCEEDED = 'API_LIMIT_EXCEED';
export const STATUS_USER_ACCOUNT_DEACTIVATED = 'USER_ACCOUNT_DEACTIVATED';
export const STATUS_USER_PROFILE_INCOMPLETE = 'STATUS_USER_PROFILE_INCOMPLETE';
export const STATUS_USER_ACCOUNT_SUSPENDED = 'STATUS_USER_ACCOUNT_SUSPENDED';
export const EMPTY_FIELD_STATUS = 'EMPTY';

export const JSON_FIELD = {
  message: 'message',
  status: 'status'
};

const IRCTC_PROFILE_VALIDATION_TYPES = {
  MOBILE: 'MOBILE',
  EMAIL: 'EMAIL',
  MOBILE_EMAIL: 'MOBILE_EMAIL',
  IRCTC: 'IRCTC',
};

const verificationTypeStatusMap = {
  [IRCTC_PROFILE_VALIDATION_TYPES.EMAIL]: STATUS_EMAIL_OTP_VERIFICATION_PENDING,
  [IRCTC_PROFILE_VALIDATION_TYPES.MOBILE]: STATUS_MOBILE_OTP_VERIFICATION_PENDING,
  [IRCTC_PROFILE_VALIDATION_TYPES.MOBILE_EMAIL]: STATUS_MOBILE_EMAIL_OTP_VERIFICATION_PENDING,
  [IRCTC_PROFILE_VALIDATION_TYPES.IRCTC]: STATUS_USER_PROFILE_INCOMPLETE,
};
/*
result status always comes in the form of x#x#x#x
where x is a number and the function calling it is in
try catch.
 */
export const parseValidateUserResponse = (result) => {
  let responseData = {};
  try {
    if (result?.isIrctcProfileComplete === true) {
      responseData[JSON_FIELD.status] = STATUS_API_SUCCESS;
      responseData[JSON_FIELD.message] = result.status;
    } else {
      const verificationFlow = result?.verificationFlow;
      responseData[JSON_FIELD.message] =
        verificationFlow?.message || _label('something_went_wrong');
      responseData[JSON_FIELD.status] =
        verificationTypeStatusMap[verificationFlow?.type] || STATUS_API_ERROR;
    }
    return responseData;
  } catch (e) {
    console.error(`parseValidateUserResponse API Failed. Error ${e}`);
    responseData[JSON_FIELD.status] = STATUS_API_ERROR;
    responseData[JSON_FIELD.message] = isEmpty(result.error)
      ? _label('something_went_wrong')
      : result.error;
    return responseData;
  }
};

const validateUserId = async (UserId) => {
  if (isEmpty(UserId)) {
    return [];
  }
  try {
    const data = {
      userName: UserId
    };
    const response = await fetch2(railsConfig.validateUserId, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
    if (response.status !== 200) {
      handleError( 'validateUserId api failed');
      return null;
    }
    const result = await response.json();
    return parseValidateUserResponse(result);
  } catch (e) {
    console.log('validateUserId API Failed.'+ " Error Code: " + e?.errorCode );
    return null;
  }
};

export const retrieveUserId = async (dateOfBirth,  emailIdOrMobileText, key) => {
  const responseData = {};
  if (isEmpty(dateOfBirth) || isEmpty(emailIdOrMobileText)) {
    responseData[JSON_FIELD.status] = EMPTY_FIELD_STATUS;
    responseData[JSON_FIELD.message] = 'Please fill required fields';
    return responseData;
  }
  try {
    const requestType = 'U';
    const data = {
      dob: dateOfBirth,
      [key]: emailIdOrMobileText
    };

    const response = await fetch2(`${railsConfig.retrieveUserId}/${requestType}`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
    const result = await response.json();
    if (response.status !== 200) {
      console.log('Retrieve User Id API Failed');
      responseData[JSON_FIELD.status] = STATUS_NON_RESPONSIVE_API_ERROR;
      responseData[JSON_FIELD.message] = 'API Failed to Response';
    }

    if (isEmpty(result.status) || isNull(result.status)) {
      responseData[JSON_FIELD.status] = STATUS_API_ERROR;
      responseData[JSON_FIELD.message] = result.error;
    } else {
      responseData[JSON_FIELD.status] = STATUS_API_SUCCESS;
      responseData[JSON_FIELD.message] = result.status;
    }
  } catch (e) {
    console.log('Retrieve User Id API Failed.' +" Error Code: " + e?.errorCode );
    responseData[JSON_FIELD.status] = STATUS_NON_RESPONSIVE_API_ERROR;
    responseData[JSON_FIELD.message] = 'API Failed to Response';
  }
  return responseData;
};

export const retrievePassword = async (userId, inputData, isMobile,showResetPasswordConfig=false) => {
  const responseData = {};
  if (isEmpty(userId) || isEmpty(inputData)) {
    responseData[JSON_FIELD.status] = EMPTY_FIELD_STATUS;
    responseData[JSON_FIELD.message] = 'Please fill required fields';
    return responseData;
  }
  try {
    const requestType = 'P';
    const data = {
      dob: '',
      userLoginId: userId,
      otpType: isMobile ? 'M' : 'E',
    };
    if(!isMobile) {
      data.email = inputData;
    } else {
      data.mobile = inputData;
    }

    if(showResetPasswordConfig) {
      data.showResetPasswordConfig = true;
    }

    const response = await fetch2(`${railsConfig.retrievePassword}/${requestType}`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
    const result = await response.json();
    if (response.status !== 200) {
      handleError( 'retrievePassword api failed');
      return null;
    }

    if (isEmpty(result.status) && result.error.indexOf('58082') !== -1) {
      responseData[JSON_FIELD.status] = STATUS_LIMIT_EXCEEDED;
      responseData[JSON_FIELD.message] = result.error;
    } else if (isEmpty(result.status)) {
      responseData[JSON_FIELD.status] = STATUS_API_ERROR;
      responseData[JSON_FIELD.message] = result.error;
    } else {
      responseData[JSON_FIELD.status] = STATUS_API_SUCCESS;
      responseData[JSON_FIELD.message] = result.status;
    }

    if(result.resetPasswordConfig) {
      responseData.resetPasswordConfig = result.resetPasswordConfig;
    }
    return responseData;
  } catch (e) {
    console.log('Retrieve Password API Failed.'+ " Error Code: " + e?.errorCode );
    return null;
  }
};

export const getOTP = async (userId, otpType) => {
  const responseData = {};
  if (isEmpty(userId) || isEmpty(otpType)) {
    responseData[JSON_FIELD.status] = EMPTY_FIELD_STATUS;
    responseData[JSON_FIELD.message] = 'Please fill required fields';
    return responseData;
  }
  try {
    const response = await fetch2(`${railsConfig.getOtp}${userId}/${otpType}`);
    const result = await response.json();
    if (response.status !== 200) {
      throw new Error(_label("something_went_wrong"));
    } else if (result.status === '') {
      responseData[JSON_FIELD.status] = STATUS_API_ERROR;
      responseData[JSON_FIELD.message] = result.error;
    } else {
      responseData[JSON_FIELD.status] = STATUS_API_SUCCESS;
      responseData[JSON_FIELD.message] = result.status;
    }
    return responseData;
  } catch (e) {
    return null;
  }
};

export const verifyOTP = async (userId, otpType, emailCode, smsCode) => {
  const responseData = {};
  if (isEmpty(userId) || isEmpty(otpType)) {
    responseData[JSON_FIELD.status] = EMPTY_FIELD_STATUS;
    responseData[JSON_FIELD.message] = 'Please fill required fields';
    return responseData;
  }
  try {
    const data = JSON.stringify({
      username: userId,
      email: !isEmpty(emailCode),
      mobile: !isEmpty(smsCode),
      email_otp: emailCode,
      mobile_otp: smsCode
    });

    const url = railsConfig.verifyOtp;
    const response = await fetch2(url, {
      method: 'POST',
      body: data,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    });
    const result = await response.json();

    if (isEmpty(result.error)) {
      responseData[JSON_FIELD.status] = STATUS_API_SUCCESS;
      responseData[JSON_FIELD.message] = result.status;
    } else {
      responseData[JSON_FIELD.status] = STATUS_API_ERROR;
      responseData[JSON_FIELD.message] = result.error;
    }
    return responseData;
  } catch (e) {
    console.log('VerifyOTP api failed.'+ " Error Code: " + e?.errorCode );
    return null;
  }
};

export default validateUserId;
